import reactStringReplace from 'react-string-replace'
import styled from 'styled-components'

import { ParcelOutline, TypeStyle, fromMd } from '@syconium/little-miss-figgy'

import { ProductCatalogVariantGroup } from '../../../../../__generated__/graphql/catalog/graphql'
import { useLocalization } from '../../../../../app/_providers/LocalizationProvider.client'
import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { IntlShippingAndTaxMsg } from '../../../../../brunswick/components/IntlShippingAndTaxMsg'

import * as SharedStyles from './styles'

type ProductDetailsPromoMessagesProps = {
  variantGroup: Pick<ProductCatalogVariantGroup, 'siteWidePromoEligible' | 'finalSale'>
}

export const ProductDetailsPromoMessages = ({ variantGroup }: ProductDetailsPromoMessagesProps) => {
  const { isUSRegion } = useLocalization()
  const {
    detailsSection: { freeShippingMessageBold, freeShippingAndReturnsMessageBold },
    pages: { product: productPageStrings },
  } = useTranslation()

  // Parse strings and replace <strong> tags with BoldText component
  const parseBoldMarkup = (text: string) =>
    reactStringReplace(text, /<strong>(.*?)<\/strong>/g, (match, i) => (
      <SharedStyles.BoldText key={i}>{match}</SharedStyles.BoldText>
    ))

  return (
    <>
      {/* Display shipping/tax information for the current locale */}
      <IntlShippingAndTaxMsg />

      {/* Promo exclusion messaging */}
      {!variantGroup.siteWidePromoEligible && (
        <PromoExclusionMessage>{productPageStrings.notEligibleForDiscount}</PromoExclusionMessage>
      )}

      {/* Free shipping messaging for domestic customers */}
      {isUSRegion && (
        <SharedStyles.ProductDetailsCopy style={{ margin: '24px 0', textAlign: 'center' }}>
          <ProductDetailsTitle>
            <span>
              {parseBoldMarkup(
                variantGroup.finalSale ? freeShippingMessageBold : freeShippingAndReturnsMessageBold
              )}
            </span>
            <ParcelOutline height={20} width={20} />
          </ProductDetailsTitle>
        </SharedStyles.ProductDetailsCopy>
      )}
    </>
  )
}

export const ProductDetailsTitle = styled(TypeStyle.BodyNano)`
  font-weight: 600;
  text-wrap: pretty;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${o => o.theme.spacing(2)};
`

export const PromoExclusionMessage = styled(TypeStyle.BodySmall)`
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  margin: ${o => o.theme.spacing(6)};

  ${fromMd} {
    margin: ${o => o.theme.spacing(6)} 0;
  }
`
